import React, { useState, useEffect } from 'react';
import { Form, Card, Button } from 'react-bootstrap';
import { apiFetch } from '../../utils/api';

export default function Filters({ filters, setFilters }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    apiFetch('/api/categories')
      .then(res => res.json())
      .then(data => setCategories(data))
      .catch(err => console.error("Ошибка категорий:", err));
  }, []);

  const handleReset = () => {
    setFilters({ search: '', category: 'all', minPrice: 0, maxPrice: 0 });
  };

  return (
    <Card className="border-0 shadow-sm sticky-top" style={{ top: '100px', zIndex: 10 }}>
      <Card.Body className="p-4">
        <h5 className="fw-bold mb-4 text-uppercase small" style={{ letterSpacing: '1px' }}>Фильтры</h5>

        <Form.Group className="mb-4">
          <Form.Label className="small fw-bold text-muted text-uppercase">Вид работ</Form.Label>
          <Form.Select 
            value={filters.category} 
            onChange={(e) => setFilters({...filters, category: e.target.value})}
            className="border-0 bg-light py-2 shadow-none"
          >
            <option value="all">Все работы</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label className="small fw-bold text-muted text-uppercase">Бюджет, ₽</Form.Label>
          <div className="d-flex flex-column gap-2">
            <Form.Control 
              type="number" 
              placeholder="От" 
              className="border-0 bg-light shadow-none"
              value={filters.minPrice || ''}
              onChange={(e) => setFilters({...filters, minPrice: Number(e.target.value)})}
            />
            <Form.Control 
              type="number" 
              placeholder="До (без лимита)" 
              className="border-0 bg-light shadow-none"
              value={filters.maxPrice || ''}
              onChange={(e) => setFilters({...filters, maxPrice: Number(e.target.value)})}
            />
          </div>
        </Form.Group>

        <Button 
          variant="link" 
          className="p-0 text-decoration-none small text-muted w-100 text-start"
          onClick={handleReset}
        >
          <i className="bi bi-arrow-counterclockwise me-1"></i> Сбросить фильтры
        </Button>
      </Card.Body>
    </Card>
  );
}
